import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

export default function VerifyEmail() {
  const t = useT();
  const nav = useNavigate();
  const { applyAuth } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState(token ? "verifying" : "invalid");
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    api.post("/auth/verify-email", { token })
      .then(({ data }) => {
        applyAuth(data.token, data.user);
        setStatus("ok");
        setTimeout(() => nav("/dashboard"), 1200);
      })
      .catch(() => setStatus("invalid"));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm space-y-6 text-center">
        <div className="flex items-center justify-center gap-2 font-heading font-extrabold text-xl"><Logo size={24} className="text-brand-yellow" /> KIHAP</div>
        {status === "verifying" && <p className="text-muted-foreground" data-testid="verify-status">{t("verify.verifying")}</p>}
        {status === "ok" && <p className="text-brand-yellow font-semibold" data-testid="verify-status">{t("verify.ok")}</p>}
        {status === "invalid" && (
          <div className="space-y-4">
            <p className="text-destructive" data-testid="verify-status">{t("verify.invalid")}</p>
            <Button onClick={() => nav("/register")} className="w-full" data-testid="verify-register">{t("register.cta")}</Button>
            <p className="text-xs text-muted-foreground"><Link to="/login" className="underline">{t("login.enter")}</Link></p>
          </div>
        )}
      </div>
    </div>
  );
}
